import { render, staticRenderFns } from "./CollectionFolder.vue?vue&type=template&id=e01ab90a&scoped=true&"
import script from "./CollectionFolder.vue?vue&type=script&lang=js&"
export * from "./CollectionFolder.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFolder.vue?vue&type=style&index=0&id=e01ab90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01ab90a",
  null
  
)

export default component.exports